<template>
	<div class="flex viewer justify-center items-center">
		<div class="bg"  @click="$emit('close')" />
		<div class="slide">
			<video :poster="preview" controls autoplay>
				<source :src="url" type="video/mp4" />
			</video>
		</div>
		<div class="close" @click="$emit('close')">
			<i class="lni lni-close"></i>
		</div>
	</div>
</template>

<script>
export default {
	name: 'VideoViewer',
	props: {
		url: String,
		preview: String,
	},
	data() {
		return {
			current: 0,
		}
	},
	mounted() {
		window.addEventListener('keydown', this.onEscape)
	},
	destroyed() {
		window.removeEventListener('keydown', this.onEscape)
	},
	methods: {
		onEscape(e) {
			if (e.key !== 'Escape') return
			this.$emit('close')
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.viewer {
	width: 100%;
	height: 100%;

	.bg {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
	}

	.slide {
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: auto;
	}

	.close {
		width: 100%;
		height: 100px;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
		opacity: 0.5;
		text-align: right;
		font-size: 24px;
		color: #fff;

		&:hover {
			opacity: 1;
		}

		i {
			padding: 13px;
		}
	}
}
</style>
